module.exports = __webpack_public_path__ + "img/slider-55.62486066.jpg";